import React from 'react';

const BackgroundWrapper = ({ children }) => {
  return (
    <div className="background-container">
      {children}
    </div>
  );
};

export default BackgroundWrapper;
